import { createContext } from 'react';

export interface NetworkStatusContextValue {
    isOnline: boolean;
    wasOffline: boolean;
}

export const NetworkStatusContext = createContext<NetworkStatusContextValue | undefined>(undefined);
